<header class="navbar navbar-fixed-top bg-system">
    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/" ng-click="mainPage()">
                <img src="img/logo-blue.svg" alt="Hodxpress.com">
            </a>
        </li>
    </ul>

    <!-- <ul class="nav navbar-nav navbar-center">
    
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/map">
                <strong class="p10 fs18">Orders</strong>
            </a>
        </li>

        <li class="hidden-xs">
            <div class="btn-group navbar-form">
                <a href="/map" class="btn btn-warning btn-rounded">
                    <i class="fa fa-map fs16"></i> Map
                </a>
                <a href="/orders" class="btn btn-success btn-rounded">
                    <i class="fa fa-list fs16"></i> Lists
                </a>
                <a href="/routing" class="btn btn-warning btn-rounded">
                    <i class="fa fa-list fs16"></i> Routing
                </a>
                <a href="/takvim" class="btn btn-default btn-rounded">
                    <i class="fa fa-calendar fs16"></i> Calendar
                </a>
            </div>
        </li>

        <li class="hidden-xs">
            <a href="/bildirimler">
                <i class="fa fa-bell fs24"></i>
            </a>
        </li>
    </ul> -->

    <ul class="nav navbar-nav navbar-center">
    </ul>

    <ul class="nav navbar-nav navbar-right">

        <div class="btn-group pull-right" ng-class="{ hidden: !isInclude(['routes'])}">
            <a href="/route-activity" 
                class="hod-button outline ml10">
                Route Activity
            </a>
            <a href="/routing" 
                class="hod-button blue ml10" >
                Edit Routes
            </a>
            <a href="#" 
                class="hod-button blue ml10" 
                ng-click="newData()">
                New Route
            </a>
        </div>

        <div class="btn-group pull-right" ng-class="{ hidden: !isInclude(['stations'])}">
            <a href="#" ng-click="newData()" class="hod-button blue ml10">
                Add New Station
            </a>
        </div>

        <!-- <div class="btn-group pull-right" ng-if="isInclude(['chats'])">
            <a href="#" ng-click="newData()" class="hod-button blue ml10">
                New Conversation
            </a>
        </div> -->

        <li class="hidden-xs">
            
        </li>

        <div class="btn-group pull-right" ng-class="{ hidden: !isActive(['offers'])}">
            <a href="#" 
                class="hod-button blue ml10" 
                ng-click="newData()">
                New Offer
            </a>
        </div>

        <div class="btn-group pull-right" ng-class="{ hidden: !isActive(['blocks'])}">
            <a href="#" 
                class="hod-button blue ml10" 
                ng-click="newData()">
                New Block
            </a>
        </div>

        <div class="btn-group pull-right" ng-class="{ hidden: !isActive(['billing'])}">
            <a href="#" 
                class="hod-button blue ml10" 
                ng-click="newData()">
                New Invoice
            </a>
        </div>

        <div class="btn-group pull-right" ng-class="{ hidden: !isActive(['earning'])}">
            <a href="#" 
                class="hod-button blue ml10" 
                ng-click="newData()">
                New Earning
            </a>
        </div>

        <div class="btn-group pull-right" ng-class="{ hidden: !isActive(['','map','orders'])}">
            <a href="/route-activity" 
                class="hod-button outline ml10">
                Route Activity
            </a> 
            <a href="/new-order" 
                class="hod-button blue ml10">
                New Order
            </a>
            <a href="#" 
                class="hod-button blue ml10" 
                id="newRoute" 
                ng-click="newRouteData()">
                New Route
            </a>
        </div>

        <li class="dropdown dropdown-fuse hidden-xs">
            
            <!-- <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                Actions <span class="fa fa-chevron-down"></span>
            </a> -->
            <ul class="dropdown-menu dropdown-menu-form p10 w200 allcp-form" role="menu">
                <li ng-class="{ hidden: !isActive(['','map'])}">
                    <a href="#"  
                        ng-click="export()" class="fs14"> <i class="fa fa-reply"></i> 
                        Export Excel
                    </a>
                </li>
                <!-- <li ng-class="{ hidden: !isActive(['','map'])}">
                    <a href="#" class="fs14" data-toggle="modal" data-target="#importOrderList"> 
                        <i class="fa fa-share"></i> İçe Aktar
                    </a>
                </li> -->

                <li ng-class="{ hidden: !isActive(['orders'])}">
                    <a href="#" class="fs14"  
                        ng-click="downloadExcel()"> <i class="fa fa-reply"></i> Export Excel</a>
                </li>
                <!-- <li ng-class="{ hidden: !isActive(['orders'])}">
                    <a href="#" class="fs14" data-toggle="modal" data-target="#importOrderList"> <i class="fa fa-share"></i> İçe Aktar</a>
                </li> -->
                <!-- <li ng-class="{ hidden: !isActive(['orders'])}">
                    <a href="#"
                        ng-click="downloadZip()">
                        <i class="fa fa-file-archive-o"></i> Zip İndir
                    </a>
                </li> -->
                <li ng-class="{ hidden: !isActive(['orders'])}">
                    <a href="#"
                        ng-if="authenticatedUser.owner"
                        data-toggle="modal" data-target="#deleteOrdersModal">
                        Delete
                    </a>
                </li>

                <!-- <div class="divider" ng-class="{ hidden: !isActive(['','map','orders'])}"></div> -->
                <!-- <li ng-class="{ active: isActive('ozel-alanlar')}"><a href="ozel-alanlar">Cargo Special Areas</a></li>
                <li ng-class="{ active: isActive('work-steps')}"><a href="work-steps">Order Statuses</a></li>
                <li ng-class="{ active: isActive('is-tipleri')}"><a href="is-tipleri">Order Types</a></li>
                <li ng-class="{ active: isActive('formlar')}"><a href="formlar">Forms</a></li> -->
                <!-- 
                    <li ng-class="{ active: isActive('checklist-sablonlar')}"><a href="checklist-sablonlar">Checklist Şablonları</a></li>
                -->
                <!-- <li ng-class="{ active: isActive('ayarlar')}" ng-if="authenticatedUser.type != 'office'">
                    <a href="/ayarlar">Settings</a>
                </li> -->
                <div class="divider" ng-class="{ hidden: !isActive(['','map'])}"></div>
                <li class="pl10" ng-class="{ hidden: !isActive(['','map'])}">
                    <div class="checkbox-custom mb5">
                        <input type="checkbox" ng-model="mapDetail.traffic" ng-checked="mapDetail.traffic" id="traffic">
                        <label for="traffic">Traffic</label>
                    </div>
                </li>
                <li class="pl10" ng-class="{ hidden: !isActive(['','map'])}">
                    <div class="checkbox-custom mb5">
                        <input type="checkbox" ng-model="mapDetail.detail_name" ng-checked="mapDetail.detail_name" id="detail_name">
                        <label for="detail_name">Named</label>
                    </div>
                </li>
                <li class="pl10" ng-class="{ hidden: !isActive(['','map'])}">
                    <div class="checkbox-custom mb5">
                        <input type="checkbox" ng-model="mapDetail.darkColor" ng-checked="mapDetail.darkColor" id="darkColor">
                        <label for="darkColor">Dark Map</label>
                    </div>
                </li>
            </ul>
        </li>

    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isInclude([ 'map', 'orders', 'routing'])">
    <ul class="nav navbar-nav navbar-left" ng-include="'modules/company/menus/order_filter.html'">
    </ul>
</header>
    
<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isInclude(['routes'])">
    
    <ul class="nav navbar-nav navbar-left">

        <div class="form-group floating">
            <select class="ml10 selectpicker" 
                multiple 
                title="By Station"
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.stations"
                ng-keyup="$event.keyCode == 13 && refreshData()"
                data-style="btn-primary">
                <option ng-repeat="item in data.stations" data-select-watcher data-last="{{$last}}" value="{{item.id}}">
                    {{ item.code }} - {{ item.city }}
                </option>
            </select>
        </div>

        <div class="form-group floating">
            <select class="ml10 selectpicker" 
                multiple 
                title="By Driver"
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.workers"
                ng-keyup="$event.keyCode == 13 && refreshData()"
                data-style="btn-primary">
                <option ng-repeat="member in data.workers | orderBy:'full_name'" ng-if="!member.user.status" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
            </select>
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                ng-model="filterData.term" 
                class="btn btn-operation ml10 text-input" 
                ng-keyup="$event.keyCode == 13 && refreshData()"
                placeholder="By Order ID">
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                ng-model="filterData.qr" 
                class="btn btn-operation ml10 text-input" 
                ng-keyup="$event.keyCode == 13 && refreshData()"
                placeholder="By QR Code">
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                options="opts" 
                date-range-picker 
                ng-model="filterData.date"
                class="btn btn-operation ml10" 
                ng-keyup="$event.keyCode == 13 && refreshData()"
                placeholder="By Date" >
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                ng-model="filterData.location" 
                class="btn btn-operation ml10 text-input" 
                placeholder="By Customer"
                ng-keyup="$event.keyCode == 13 && refreshData()">
        </div>

        <div class="form-group floating">            
            <select class="ml10 selectpicker" 
                multiple 
                title="By Status"
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.status"
                ng-keyup="$event.keyCode == 13 && refreshData()"
                data-style="btn-primary">
                <option ng-repeat="item in [{ id : 0, name : 'Created' }, { id : 1, color: 'complete', name : 'Completed' }]" 
                    data-select-watcher 
                    data-last="{{$last}}" 
                    class="color-{{item.color}}"
                    value="{{item.id}}">
                    {{item.name}}
                </option>
            </select>
        </div> 

        <a href="#" 
            class="btn w50 p-2 ml10" 
            ng-click="refreshData('routes')" 
            style="line-height: 20px;"
            ng-show="filterData.stations.length > 0 || 
                filterData.workers.length > 0 || 
                filterData.term || 
                filterData.qr || 
                filterData.date.startDate || 
                filterData.status || 
                filterData.location">
            <i class="fa fa-refresh"></i>
        </a>
        <a href="#" 
            ng-show="filterData.stations.length > 0 || 
            filterData.workers.length > 0 || 
            filterData.term || 
            filterData.qr || 
            filterData.date.startDate || 
            filterData.status || 
            filterData.location" 
            class="clear-filter ml-3" 
            ng-click="clearFilter()" style="line-height: 20px;">
            Clear Filter
        </a>
    </ul>
</header>

<!--

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['form'])">
        
    <ul class="nav navbar-nav navbar-left">
        <a href="/formlar" class="btn btn-operation ml20" style="line-height: 17px;"> Tüm Formlar </a>
            <a href="/ornek-formlar" class="btn btn-operation ml20" style="line-height: 17px;"> Örnek Formlar </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <button type="submit" class="btn btn-warning btn-rounded" style="height: 30px;line-height: 20px;font-weight:600"> Kaydet</a>
        </li>

    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['formlar'])">
    
    
    <ul class="nav navbar-nav navbar-left">
        <a href="/ornek-formlar" class="btn btn-operation ml20" style="line-height: 17px;"> Örnek Formlar </a>

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Form Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            Sil
        </a>
    </ul>
    

    <ul class="nav navbar-nav navbar-right">
        <li class="hidden-xs">
            <a href="/form/yeni" class="btn btn-warning btn-rounded">
                 Yeni Form Ekle
            </a>
        </li>
    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['is-tipleri'])">
    
    <ul class="nav navbar-nav navbar-left">

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="KargoTipi Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            Sil
        </a>
    </ul>
    

    <ul class="nav navbar-nav navbar-right">
        <li class="hidden-xs">
            <a href="is-tipleri/yeni" class="btn btn-warning btn-rounded">
                 KargoTipi Ekle
            </a>
        </li>
    </ul>
</header>
-->

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['bildirimler'])">

    <ul class="nav navbar-nav navbar-left">

        <input 
            type="text" 
            ng-model="filterData.term" 
            class="btn btn-operation ml10 text-input" 
            placeholder="Kargo No">

        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.created_at" 
            class="btn btn-operation ml10" 
            placeholder="Oluşturma Tarihi" >
        
        <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select>

        <select class="ml10 selectpicker" 
            multiple 
            title="Bildirim Türü"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workSteps"
            data-style="btn-primary">
            <option ng-repeat="item in data.steps" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select>

        <a href="#" class="btn btn-warning ml10" ng-click="refreshData('orders')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>
        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="#" 
                id="newOrder" 
                class="navbar-fullscreen btn btn-warning btn-rounded" 
                data-toggle="modal" 
                data-target="#newOrder" 
                ng-click="newTaskModal()">
                Kargo Oluştur
            </a>
        </li>

        <li class="dropdown dropdown-fuse hidden-xs">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                İşlemler <span class="fa fa-chevron-down"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-form p10 w200" role="menu">
                <li>
                    <a href="#" class="fs14"  
                        ng-click="downloadExcel()"> <i class="fa fa-reply"></i> Dışa Aktar</a>
                </li>
            </ul>
        </li>
        
    </ul>
    
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['route-activity'])">

    <ul class="nav navbar-nav navbar-left">

        <input 
            type="text" 
            ng-model="filterData.term" 
            class="btn btn-operation ml10 text-input" 
            placeholder="By Route Number">

        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.created_at" 
            class="btn btn-operation ml10" 
            placeholder="By Date" >
        
        <select class="ml10 selectpicker" 
            multiple 
            title="By Type"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.types"
            data-style="btn-primary">
            <option ng-repeat="item in types" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select>

        <a href="#" 
            class="btn w50 p-2 ml10" 
            ng-click="refreshData('routes')" 
            style="line-height: 20px;"
            ng-show="filterData.types.length > 0 || 
                filterData.term || 
                filterData.created_at.startDate">
            <i class="fa fa-refresh"></i>
        </a>
        <a href="#" 
            ng-show="filterData.types.length > 0 || 
            filterData.term || 
            filterData.created_at.startDate" 
            class="clear-filter ml-3" 
            ng-click="clearFilter()" style="line-height: 20px;">
            Clear Filter
        </a>

    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['ozel-alanlar'])">
    
    <ul class="nav navbar-nav navbar-left">

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Özel Alan Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            Sil
        </a>
    </ul>
    

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="ozel-alanlar/yeni" class="btn btn-warning btn-rounded">
                Yeni Özel Alan Ekle
            </a>
        </li>

    </ul>
    
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['checklist-sablonlar'])">
    
    <ul class="nav navbar-nav navbar-left">

        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Checklist Şablon Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            Sil
        </a>
    </ul>
    

    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="checklist-sablonlar/yeni" class="btn btn-warning btn-rounded">
                Yeni Checklist Şablon Ekle
            </a>
        </li>

    </ul>
    
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['stations'])">
    
    <ul class="nav navbar-nav navbar-left">

        <input type="text" 
            class="btn btn-operation ml10 text-input" 
            ng-model="data.term" 
            placeholder="By Station Name">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            Delete
        </a>
    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['chats'])">
    
    <ul class="nav navbar-nav navbar-left">

        <input type="text" 
            class="btn btn-operation ml10 text-input" 
            ng-model="filterData.term" 
            placeholder="Search Conversation"
            ng-keyup="$event.keyCode == 13 && all()">

        <a href="#" 
            class="btn w50 p-2 ml10" 
            ng-click="all()" 
            style="line-height: 20px;"
            ng-show="filterData.term">
            <i class="fa fa-refresh"></i>
        </a>
        <a href="#" 
            ng-show="filterData.term" 
            class="clear-filter ml-3" 
            ng-click="clearFilter()" style="line-height: 20px;">
            Clear Filter
        </a>
    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['offers', 'blocks'])">

    <ul class="nav navbar-nav navbar-left">

        <div class="form-group floating">
            <select class="ml10 selectpicker" 
                multiple 
                title="By Station"
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.station_id"
                data-style="btn-primary"
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <option ng-repeat="item in data.stations" data-select-watcher data-last="{{$last}}" value="{{item.id}}">
                    {{ item.code }}
                </option>
            </select>
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                ng-model="filterData.price" 
                class="btn btn-operation ml10 text-input" 
                placeholder="By Price"
                ng-keyup="$event.keyCode == 13 && refreshData()">
        </div>

        <div class="form-group floating">
            <select class="ml10 selectpicker" 
                multiple 
                title="By Vehicle"
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.vehicle"
                data-style="btn-primary"
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <option ng-repeat="item in ['Small','Medium','Large']" data-select-watcher data-last="{{$last}}" value="{{item}}">{{item}}</option>
            </select>
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                options="opts" 
                date-range-picker 
                ng-model="filterData.date"
                class="btn btn-operation ml10" 
                placeholder="By Date" 
                ng-keyup="$event.keyCode == 13 && refreshData()">
        </div>

        <div class="form-group">
            <a href="#"
               class="btn w50 p-2 ml10"
               ng-show="
                filterData.station_id.length > 0 ||
                filterData.date.startDate || 
                filterData.vehicle.length > 0 || 
                filterData.price"
               ng-click="refreshData('map')">
                <i class="fa fa-refresh"></i>
            </a>
        </div>
        <div class="form-group"
            ng-show="
                filterData.station_id.length > 0 ||
                filterData.date.startDate || 
                filterData.vehicle.length > 0 || 
                filterData.price">
            <a href="#" class="clear-filter ml-3" ng-click="clearFilter()">
                Clear Filter
            </a>
        </div>
    </ul>
   
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['billing'])">

    <ul class="nav navbar-nav navbar-left">

        <div class="form-group floating">
            <select class="ml10 selectpicker" 
                multiple 
                title="By Partner"
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.company_customer_id"
                data-style="btn-primary"
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <option ng-repeat="item in data.customers" data-select-watcher data-last="{{$last}}" value="{{item.id}}">
                    {{ item.dba_name ? item.dba_name : item.customer_name }}
                </option>
            </select>
        </div>

        <div class="form-group floating ml10">
            <input
                type="text"
                class="btn btn-operation text-input form-control" 
                ng-model="filterData.term" 
                placeholder="By Invoice ID"
                ng-keyup="$event.keyCode == 13 && refreshData()">
            <label>By Invoice ID</label>
        </div>

        <div class="form-group floating ml10">
            <input type="text" 
                options="opts" 
                date-range-picker 
                class="btn btn-operation text-input form-control" 
                ng-model="filterData.date" 
                placeholder="Date Filter"
                ng-keyup="$event.keyCode == 13 && refreshData()">
            <label>By Date</label>
        </div>

        <div class="form-group ml10">
            <select class="selectpicker"
                multiple
                title="By Status"
                data-selected-text-format="count"
                data-language="tr_TR"
                ng-model="filterData.status"
                data-style="btn btn-primary" 
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <option 
                    ng-repeat="item in statuses" 
                    data-select-watcher 
                    data-last="{{$last}}" 
                    value="{{item.id}}"
                    class="color-{{item.value}}">
                    {{item.name}}
                </option>
            </select>
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                ng-model="filterData.price" 
                class="btn btn-operation ml10 text-input" 
                placeholder="By Price"
                ng-keyup="$event.keyCode == 13 && refreshData()">
        </div>

        <div class="form-group">
            <a href="#"
               class="btn w50 p-2 ml10"
               ng-show="
                filterData.company_customer_id.length ||
                filterData.term ||
                filterData.date.startDate ||
                filterData.status.length ||
                filterData.price"
               ng-click="refreshData('map')">
                <i class="fa fa-refresh"></i>
            </a>
        </div>
        <div class="form-group"
            ng-show="filterData.company_customer_id.length ||
            filterData.term ||
            filterData.date.startDate ||
            filterData.status.length ||
            filterData.price">
            <a href="#" class="clear-filter ml-3" ng-click="clearFilter()">
                Clear Filter
            </a>
        </div>
    </ul>
   
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isInclude(['earning'])">

    <ul class="nav navbar-nav navbar-left">

        <div class="form-group floating">
            <select class="ml10 selectpicker" 
                multiple 
                title="By Worker"
                data-live-search="true" 
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.workers"
                data-style="btn-primary"
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <option ng-repeat="item in data.workers" data-select-watcher data-last="{{$last}}" value="{{item.id}}">
                    {{ item.full_name }}
                </option>
            </select>
        </div>

        <div class="form-group floating ml10">
            <input 
                type="text" 
                class="btn btn-operation text-input form-control" 
                ng-model="filterData.term" 
                placeholder="By Invoice ID"
                ng-keyup="$event.keyCode == 13 && refreshData()">
            <label>By Invoice ID</label>
        </div>

        <div class="form-group floating ml10">
            <input 
                type="text" 
                options="opts" 
                date-range-picker 
                class="btn btn-operation text-input form-control" 
                ng-model="filterData.date" 
                placeholder="Date Filter"
                ng-keyup="$event.keyCode == 13 && refreshData()">
            <label>By Date</label>
        </div>

        <div class="form-group ml10">
            <select class="selectpicker"
                multiple
                title="By Status"
                data-selected-text-format="count"
                data-language="tr_TR"
                ng-model="filterData.status"
                data-style="btn btn-primary" 
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <option 
                    ng-repeat="item in statuses" 
                    data-select-watcher 
                    data-last="{{$last}}" 
                    value="{{item.id}}"
                    class="color-{{item.value}}">
                    {{item.name}}
                </option>
            </select>
        </div>

        <div class="form-group floating">
            <input 
                type="text" 
                ng-model="filterData.price" 
                class="btn btn-operation ml10 text-input" 
                placeholder="By Price"
                ng-keyup="$event.keyCode == 13 && refreshData()">
        </div>

        <div class="form-group">
            <a href="#"
               class="btn w50 p-2 ml10"
               ng-show="
                filterData.workers.length > 0 ||
                filterData.term ||
                filterData.date.startDate ||
                filterData.status.length > 0 ||
                filterData.price"
               ng-click="refreshData('map')">
                <i class="fa fa-refresh"></i>
            </a>
        </div>
        <div class="form-group"
            ng-show="
                filterData.workers.length > 0 ||
                filterData.term ||
                filterData.date.startDate ||
                filterData.status.length > 0 ||
                filterData.price">
            <a href="#" class="clear-filter ml-3" ng-click="clearFilter()">
                Clear Filter
            </a>
        </div>
    </ul>
   
</header>